// extracted by mini-css-extract-plugin
module.exports = {"mainSidebar":"Sidebar_mainSidebar__wfJqz","logo":"Sidebar_logo__3htur","navLink":"Sidebar_navLink__2QU6Z","sideIcon":"Sidebar_sideIcon__3_6cq"};